export default __webpack_public_path__ + "static/media/bg-registration3.3fec4ade.jpg";